import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';



const NumberBlockSetupFeeField = ({ errors, touched,  darkMode, name = 'setupFee' }) => {
    const [isHovered, setIsHovered] = useState(false);
    const error = errors[name];
    const showError = touched[name];
    return (
        <FormControl sx={{ margin: '0 !important' }} isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Setup Fee <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the setup fee for this number block rate.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                       <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-start',
                                                                                paddingTop: '2px',
                                                                            }}>
                    <VStack width="100%" alignItems="normal">
                        <Field
                            as={NameField}
                            id="setupFee"
                            name="setupFee"
                            error={errors.setupFee}
                            type="number"
                            step="any"
                        />
                        {showError && (
                            <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                {error}
                            </Text>
                        )}
                    </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the setup fee."
                        ariaLabel="number-block-setup-fee-tip"
                        left="25px"
                        top="25px   "
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NumberBlockSetupFeeField;
